import { render, staticRenderFns } from "./vc-msgeif.vue?vue&type=template&id=1ed08b34&scoped=true&"
import script from "./vc-msgeif.vue?vue&type=script&lang=js&"
export * from "./vc-msgeif.vue?vue&type=script&lang=js&"
import style0 from "./vc-msgeif.vue?vue&type=style&index=0&id=1ed08b34&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed08b34",
  null
  
)

export default component.exports